import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CheckRegisterFlagQueryResponse, CheckRegisterFlagQueryParams } from "../../types/CheckRegisterFlag";

/**
     * @summary Запрос на проверку флага регистрации
     * @link /api/auth/check/feature_flag
     */
export async function checkRegisterFlag (params: CheckRegisterFlagQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<CheckRegisterFlagQueryResponse>["data"]> {
    const { data: resData } = await client<CheckRegisterFlagQueryResponse>({
        method: "get",
        url: `/api/auth/check/feature_flag`,
        params,
        ...options
    });
    
    return resData;
};